/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassCocktailIcon16Solid = forwardRef('FoodDrinkAlcoGlassCocktailIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.916 1.612c-.414.386-.73.862-.924 1.388H2.04C.845 3 .219 4.418 1.023 5.3L6 10.767V13H3.5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H8v-2.234l2.926-3.213a3.607 3.607 0 1 0-1.01-5.94ZM10.312 6l1.366-1.5H2.322L3.69 6h6.623Z" })));
});
